import Crud from '../views/Usuario/Crud'
import Entity from '../views/Usuario/View'

let routes = {
    path: '/usuarios',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/usuarios/view/:id?',
            name: 'ViewUsuario',
            component: Entity,
            meta: {
                pageTitle: "Visualizar Usuários",
                breadcrumb: [
                    {
                        text: "usuários",
                        active: false,
                        to: '/usuarios',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/usuarios',
            name: 'list-usuarios',
            component: Crud,
            meta: {
                pageTitle: "Lista de Usuários",
                breadcrumb: [
                    {
                        text: "usuários",
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
